import styled from 'styled-components'

export default styled.img`
  vertical-align: top;
  height: auto;
  max-width: 116%;
  width: 116%;
  margin-top: 8vw;
  margin-bottom: 8vw;
  margin-left: calc(100% / -12);
  /* margin-right: calc(100% / -12); */
  @media  (max-width: 40em) {
    margin-top: 40px;
    margin-bottom: 40px;
    max-width: 100%;
    width: 100%;
    margin-left: 0;
  }
`
